import { createSelector } from '@ngrx/store';
import * as fromAppState from '../states/app.state';

export const getCurrentUser = createSelector(
  fromAppState.getSectionUsers,
  users => users.currentUser
);

export const isUserAuthenticated = createSelector(
  fromAppState.getSectionUsers,
  users => users.isAuthenticated
);

export const getLoginError = createSelector(
  fromAppState.getSectionUsers,
  users => users.errorText
);

export const getUserPermissions = createSelector(
  fromAppState.getSectionUsers,
  users => users.currentUser?.orgUnitPermissions.filter(o => o.organizationalUnitId == users.currentUser?.currentOrgUnitId)[0]?.capabilities ?? []
);

export const hasSwtichedTenant = createSelector(
  fromAppState.getSectionUsers,
  users => users.currentUser?.baseSwitchTenant != users.currentUser?.currentTenant
);

export const getOrgUnits = createSelector(
  fromAppState.getSectionUsers,
  users => users.currentUser?.orgUnitPermissions || []
)

export const switchBaseTenant = createSelector(
  fromAppState.getSectionUsers,
  users => users.currentUser?.baseSwitchTenant
);

export const currentTenant = createSelector(
  fromAppState.getSectionUsers,
  users => users.currentUser?.currentTenant
);

export const currentTenantName = createSelector(
  fromAppState.getSectionUsers,
  users => users.currentUser?.currentTenantName
);

export const getCurrentOrgUnit = createSelector(
  fromAppState.getSectionUsers,
  users => users.currentUser?.currentOrgUnitId
);

